'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDefined;
/**
 * Check if `param` is defined.
 *
 * @param {*} param The value to check
 * @returns {boolean} Returns `false` when `param` is `undefined` otherwise true.
 */
function isDefined(param) {
  return typeof param !== 'undefined';
}
//# sourceMappingURL=isDefined.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/~/d2-utilizr/lib/isDefined.js
 ** module id = 69
 ** module chunks = 0 1
 **/